import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCategory } from '../redux/actions/categoryActions';
import { fetchGamesByCategory } from '../redux/actions/gameActions';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const dispatch = useDispatch();
  const { categories, categoriesLoaded } = useSelector(state => state.categories);
  const { selectedCategory } = useSelector(state => state.categories);

  // 在分类数据加载完成后选中第一个分类并加载游戏
  useEffect(() => {
    if (categoriesLoaded && Array.isArray(categories) && categories.length > 0 && !selectedCategory) {
      console.log('Setting initial category:', categories[0]);
      const firstCategory = categories[0];
      
      // 使用 Promise.all 确保操作顺序
      const initializeCategory = async () => {
        try {
          // 先设置选中的分类
          await dispatch(setSelectedCategory(firstCategory.slug));
          // 然后获取该分类的游戏
          await dispatch(fetchGamesByCategory(firstCategory.slug));
        } catch (error) {
          console.error('Error initializing category:', error);
        }
      };

      initializeCategory();
    }
  }, [categories, categoriesLoaded, selectedCategory, dispatch]);

  // 获取分类对应的图标
  const getGenreIcon = (slug) => {
    const icons = {
      'action': '🎮',
      'adventure': '🗺️',
      'card-game': '🃏',
      'educational': '📚',
      'fighting': '🥊',
      'interactive-fiction': '📖',
      'platformer': '🏃',
      'puzzle': '🧩',
      'racing': '🏎️',
      'rhythm': '🎵',
      'role-playing': '⚔️',
      'shooter': '🎯',
      'simulation': '🎮',
      'sports': '⚽',
      'strategy': '♟️',
      'survival': '🏕️',
      'visual-novel': '📚'
    };
    return icons[slug] || '🎮';
  };

  // 处理分类点击
  const handleCategoryClick = async (categoryId) => {
    const newSelectedCategory = selectedCategory === categoryId ? null : categoryId;
    
    try {
      // 先更新选中的分类
      await dispatch(setSelectedCategory(newSelectedCategory));
      // 然后获取对应的游戏列表
      await dispatch(fetchGamesByCategory(newSelectedCategory));
    } catch (error) {
      console.error('Error handling category click:', error);
    }
  };

  // 确保 categories 是数组
  const categoriesList = Array.isArray(categories) ? categories : [];

  return (
    <div className="sidebar">
      {/* 分类标题 */}
      <h2 className="sidebar-title">Genre</h2>
      
      {/* 分类列表 */}
      <ul className="genre-list">
        {categoriesList.map(category => (
          <li 
            key={category._id} 
            className={`genre-item ${selectedCategory === category.slug ? 'active' : ''}`}
            onClick={() => handleCategoryClick(category.slug)}
          >
            <span className="genre-icon">{getGenreIcon(category.slug)}</span>
            <span className="genre-name">{category.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
